<template>
  <div>
    <CChartPie
      :datasets="datasets"
      :labels="labels"
    />

    <CElementCover :opacity="0.9" v-show="loading" />
  </div>
</template>

<script>
import { CChartPie } from '@coreui/vue-chartjs'
import colors from "./colors.js";

export default {
  name: "ChartRevenueByReferer",
  components: { CChartPie },
  props: {
    year: { default: null, type: String  },
    month: { default: null, type: Number },
    week: { default: null, type: Object },
    restaurant: { default: null, type: Number },
    billingEntityId: { default: null, type: Number },
    billingEntityCountryCode: { default: null, type: String },
    revenues: { default: null, type: Array },
  },
  data() {
    return {
      datasets: [],
      labels: [],
      loading: false
    };
  },

  async mounted() {
    this.getDetailsByReferer();
  },

  methods: {
    async getDetailsByReferer() {
      this.loading = true;

      var url = new URL(this.$backend.REPORTS.REVENUE_DETAILS_REFERER),
        params = {
          year: this.year,
          month: this.month,
          week: this.week?.start,
          "restaurant-id": this.restaurant,
          billing_entity_id: this.billingEntityId,
          billing_entity_country_code: this.billingEntityCountryCode,
        };

      Object.keys(params).forEach((key) => {
        if (
          typeof params[key] !== "undefined" &&
          params[key] !== null &&
          params[key] !== "" &&
          params[key].length !== 0
        )
          url.searchParams.append(key, params[key]);
      });

      await this.$axios.get(url)
        .then((response) => {
          this.labels = response.data.values.map((v) => v.referer);

          this.datasets.push({
            data: response.data.values.map((v) => v.total),
            backgroundColor: response.data.values.map((v, index) => colors[index + 15] + "BB"), // 80 -> 50% alpha
          });

          this.$emit("update:revenues", response.data.values)
        })
        .finally(() => this.loading = false)
    },
  },
};
</script>
